// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2a03449","977":"63a88426"}[chunkId] + ".chunk.js";
};